export const contactIs = {
  hero: {
    title: 'Hafðu samband',
    subtitle: 'Við erum hér til að svara spurningum þínum og taka á móti ábendingum',
  },
  getInTouch: {
    title: 'Hafðu samband',
    subtitle: 'Ertu með spurningu, tillögu eða vilt bóka borð? Við myndum elska að heyra frá þér.',
    location: 'Staðsetning okkar',
    phone: 'Sími',
    email: 'Netfang',
    hours: 'Opnunartími',
    hoursDetails: {
      weekdays: 'Mánudagur - Laugardagur: 12:00 - 22:00',
      sunday: 'Sunnudagur: 17:00 - 22:00',
    },
  },
  form: {
    title: 'Sendu okkur skilaboð',
    name: 'Fullt nafn',
    email: 'Netfang',
    phone: 'Símanúmer',
    subject: 'Efni',
    message: 'Skilaboð',
    button: 'Senda skilaboð',
    confirmation: 'Skilaboðin þín hafa verið send. Við munum hafa samband við þig fljótlega!',
    defaultNote: 'Við munum hafa samband við þig eins fljótt og auðið er.',
    placeholders: {
      name: 'Fullt nafn þitt',
      email: 'Netfangið þitt',
      phone: 'Símanúmerið þitt (valfrjálst)',
      subject: 'Hvað varðar þetta?',
      message: 'Skilaboðin þín',
    },
  },
  faq: {
    title: 'Algengar spurningar',
    subtitle: 'Hér finnurðu svör við algengum spurningum um veitingastaðinn okkar',
    items: [
      {
        question: 'Takið þið á móti bókunum?',
        answer:
          'Já, við mælum eindregið með því að bóka borð, sérstaklega fyrir kvöldverð og um helgar. Þú getur bókað borð í gegnum vefsíðuna okkar, í síma eða með tölvupósti.',
      },
      {
        question: 'Bjóðið þið upp á grænmetis- og vegan valkosti?',
        answer:
          'Já, við erum með nokkra grænmetisvalkosti merkta á matseðlinum okkar. Þó að hefðbundin napólsk matargerð innihaldi oft mjólkurafurðir, getum við aðlagað marga rétti til að vegan mataræði samkvæmt beiðni.',
      },
      {
        question: 'Getið þið tekið á móti gestum með ofnæmi eða sérfæði?',
        answer:
          'Algjörlega. Vinsamlegast láttu okkur vita af ofnæmi eða sérfæðisþörfum þegar þú pantar borð, og kokkarnir okkar munu með ánægju koma til móts við þarfir þínar.',
      },
      {
        question: 'Eruð þið með bílastæði?',
        answer:
          'Við erum ekki með einkabílastæði, en hægt er að finna bílastæði á götunni í nágrenninu auk nokkurra bílastæðahúsa í göngufæri.',
      },
    ],
  },
};
